import { createSelector } from '@ngrx/store';
import { Order } from '../../../models';
import { AppState } from '../app.state';

export const selectOpenOrders = createSelector(
  (state: AppState) => state.orders.data,
  (orders: Order[]) => orders
);
